import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import useBrandingToolsApi from '@/api/brandingTools';
import DcLoaderPane from '@/components/_shared/DcSpinner/DcLoaderPane.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { loading } = useBrandingToolsApi();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(loading))
    ? (_openBlock(), _createBlock(DcLoaderPane, { key: 0 }))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}
}

})